<template>
<div class="step-qna customer-questions-section">
  <div class="d-flex justify-content-center">
    <h4 class="center">Tell us about you</h4>    
  </div>
  <div class="d-flex justify-content-center">
    <div class="contain">
      <b-form-group
        id="fieldset-1"
        description=""
        label="Your full name"
        label-for="full-name"
      >
        <b-form-input 
          id="full-name" 
          v-model="customerInfo.fullName" lazy
          aria-describedby="input-live-help input-live-feedback"
          @blur="updateCustomerFullName()" required trim
          :state="this.isElementValid($v.customerInfo.fullName)"
        ></b-form-input>
        <b-form-invalid-feedback id="input-live-feedback">
            Please enter a full name
        </b-form-invalid-feedback>
      </b-form-group>
    </div>
  </div>
  <div class="row justify-content-center  pt-2">
    <div class="contain">
        <b-form-group
            id="fieldset-2"
            description=""
            label="Your phone number"
            label-for="phone"
        >
            <div class="row">
              <div class="col">
                <b-form-input
                    id="phone"
                    v-model="formattedCustomerPhone"
                    lazy
                    aria-describedby="input-live-help input-live-feedback"
                    @blur="updateCustomerPhone()" required trim
                    :state="this.isElementValid($v.formattedCustomerPhone)"
                    pattern="[0-9]*" inputmode="numeric"
                    maxlength="14"
                    type="tel"
                    v-mask="'(###) ###-####'"
                    :disabled="customerInfo.phoneIsValid"
                ></b-form-input>
              </div>
            </div>
            <b-form-invalid-feedback id="input-live-feedback">
                Enter your 10 digit phone number
            </b-form-invalid-feedback>

            <div class="row align-middle" v-if="this.customerInfo.phone"
                 style="padding-top: 10px;">
                <div class="col-8 align-middle">
                    <div class="d-sm-inline-flex">Please verify your telephone</div>
                    <div class="d-sm-inline-flex">
                        <b-button pill size="sm" variant="primary" style="margin-left: 15px;background-color: #00b4ef;color:#fff;"
                                  :disabled="customerInfo.phoneIsValid"
                                  @click="sendVisitorAVerificationCode('CALL')">Call me
                        </b-button>
                        <b-button pill size="sm" variant="primary" style="margin-left: 15px;background-color: #00b4ef;color:#fff;"
                                  :disabled="customerInfo.phoneIsValid"
                                  @click="sendVisitorAVerificationCode('SMS')">Text me
                        </b-button>
                    </div>
                </div>
                <div class="col-4 position-relative">
                    <b-spinner v-if="requesting" type="grow" label="Loading..." class="position-absolute" style="right:0;"></b-spinner>
                    <b-form-input maxlength="4" id="phone-verify" v-model="verificationCode" required trim
                                  pattern="[0-9]*" inputmode="numeric"
                                  @input="validateVisitorVerificationCode" :state="customerInfo.phoneIsValid"
                                  @keypress.enter.prevent
                                  :disabled="customerInfo.phoneIsValid"
                                  placeholder="Enter Code" style="min-width:108px"></b-form-input>
                </div>
            </div>
            <div class="row" v-if="customerInfo.phoneIsValid">
                <div class="col">
                    <p style="margin-top:5px;font-weight: bold; color: green">Verified!</p>
                </div>
            </div>
            <div class="row" v-if="apiErrorMessage">
                <div class="col">
                    <p style="margin-top:5px;font-weight: bold; color: red">{{ apiErrorMessage }}</p>
                </div>
            </div>
        </b-form-group>
    </div>
  </div>
  <div class="d-flex justify-content-center">
    <div class="contain">
      <b-form-group
        id="fieldset-3"
        description=""
        label="Email"
        label-for="email"
      >
        <b-form-input id="email" v-model="customerInfo.email" lazy
        @blur="updateCustomerEmail()" trim
        :state="this.isElementValid($v.customerInfo.email)"
        ></b-form-input>

        <b-form-invalid-feedback id="input-live-feedback">
        Enter your email address (john@example.com)
        </b-form-invalid-feedback>
      </b-form-group>
    </div>
  </div>
  <section>
    <div class="row justify-content-center">
      <div class="contain">
        <p style="font-weight: bold;">There's zero obligation and our service is 100% FREE.</p>
        <p>Why this information is required:</p>
        <ul class="info-list">
          <li>In order to receive the advertised commissions from top agents in your market.</li>
          <li>We use your name, email address and phone number to verify the accuracy of your submission.</li>
          <li>We will not spam or sell your information like other real estate websites.</li>
          <li>We use 256-bit encryption to keep your information secure.</li>
        </ul>
        <p class="agree-to-terms">
          <label><input type="hidden" id="leadid_tcpa_disclosure"/>
              By clicking "Finish" I expressly consent to receive autodialed/auto-selected and/or prerecorded 
              marketing calls and/or texts to my telephone number provided above in order to receive information 
              and promotional offers, even if I am on a federal or state do not call registry.  I represent that 
              the phone number I enter is owned by me and /or I am its authorized user.  Calls/texts may be from 
              Ideal Agent, one of Ideal Agent's network of Realtor partners, and/or Ideal Agent's moving 
              concierge partner Infinity Sales Group.  I understand that consent is not a condition of purchase.  
              Standard phone and messaging rates may apply.
          </label>
        </p>
      </div>
    </div>
  </section>
</div>
</template>
<script>
import {
    saveField,
    validateVerificationCode,
    sendVerificationCode
} from "@/services/apiService";
import { required, minLength, email } from 'vuelidate/lib/validators';
import { mask } from 'vue-the-mask';

export default {
  name: 'customerInfo',
  directives: { mask },
  data() {
    return {
      customerInfo: {
        fullName: null,
        phone: null,
        phoneIsValid: null,
        email: null
      },
      formattedCustomerPhone: '',
      verificationCode: null,
      mustValidatePhone: null,
      apiErrorMessage: null,
      requesting: false,
    }
  },
  validations: {
    customerInfo: {
      fullName: {
          required,
          minLength: minLength(3)
      },
      email: {
          required,
          email
      },
    },
    formattedCustomerPhone: {
      required,
      minLength: minLength(14)
    }
  },
  methods: {
      showMessage: function (message) {
        this.$bvModal.msgBoxOk(message, {centered: true});
      },
      updateCustomerFullName: function () {
        this.$v.customerInfo.fullName.$touch();
        if (!this.$v.customerInfo.fullName.$invalid) {
            this.$emit('on-customer-info-update', this.customerInfo);
            saveField('customer_full_name', this.customerInfo.fullName);
        }
      },
      updateCustomerPhone: function () {
        this.$v.formattedCustomerPhone.$touch();
        this.customerInfo.phone = this.formattedCustomerPhone
            .replace('(', '')
            .replace(')', '')
            .replace(' ', '')
            .replace('-', '');
        this.$emit('on-customer-info-update', this.customerInfo);
        if (!this.$v.formattedCustomerPhone.$invalid) {
          saveField('customer_phone', this.customerInfo.phone);
        }
      },
      updateCustomerEmail: function () {
        this.$v.customerInfo.email.$touch();
        this.$emit('on-customer-info-update', this.customerInfo);
        saveField('customer_email', this.customerInfo.email);
      },
      sendVisitorAVerificationCode: async function (type) {

        if (!this.customerInfo.phone || this.customerInfo.phone.length != 10) {
            this.showMessage('You must enter a 10 digit phone number first');
            return;
        }

        this.requesting = true;
        const response = await sendVerificationCode(type, this.customerInfo.phone);
        this.requesting = false;

        this.apiErrorMessage = null;
        if (response?.errorMessage) {
            this.apiErrorMessage = response.errorMessage;
            return;
        }

        if (response?.message === 'approved') {
            this.customerInfo.phoneIsValid = true;
        }
        else if (response?.message !== 'pending') {
            console.error(`Unable to send code, error message: ${response.message}`)
        }
        else if (type === 'SMS') {
            this.showMessage('Great! Now check your text messages and enter the code sent')
        } else {
            this.showMessage('Great! Now answer the call to your phone and enter the code being spoken')
        }
      },
      validateVisitorVerificationCode: async function () {
          if (this.verificationCode.length !== 4) {
              return;
          }
          this.requesting = true;
          const response = await validateVerificationCode(this.verificationCode, this.customerInfo.phone);
          this.requesting = false;      
          
          this.apiErrorMessage = null;
          if (response?.errorMessage) {
              this.apiErrorMessage = response.errorMessage;
              return;
          }                
          
          this.customerInfo.phoneIsVerified = response?.status === 200;
          this.customerInfo.phoneIsValid = response?.message === 'approved';
      },
      validateEmail: function (email) {
          const re = /\S+@\S+\.\S+/;
          return re.test(String(email).toLowerCase());
      },
      validateOnlyNumbers(phone) {
          const re = /\D/;
          return !re.test(phone);
      },
      validateName: function (name) {
          if (this.isEmpty(name)) {
              this.states.name = false;
              return;
          }
          if (this.name.length > 2) {
              this.states.name = true;
              return;
          }
          this.states.name = false;
      },
      /**
       * Determines if an element is valid and returns a value used for displaying validation
       * @param vFormElement vuelidate form element
       * @returns {null|boolean} null if the element hasn't been touched, false if it has been touched and fails validation
       * and true if it has been touched and passes validation
       */
      isElementValid: function (vFormElement) {
        if (!vFormElement) {
          return null;
        }
        if (!vFormElement.$dirty) {
          return null;
        }

        if (vFormElement.$invalid) {
          return false;
        }

        if (!vFormElement.$invalid && vFormElement.$dirty) {
          return true;
        }
        return null;
      }

  }
}
</script>
<style scoped>
.info-list {
    text-align: left;
    margin-left: 10px;
}

.info-list li {
    font-size: 0.75em;        
    text-align: justify;
}

.agree-to-terms {
    font-size: 0.75em;
    text-align:justify;
}

</style>
